import type { SfcApi } from "./api-types";
import { orpcClient } from "@/lib/orpc-client";

export const warRoomClient = orpcClient as unknown as SfcApi;
